import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'
import { Auth } from 'aws-amplify'
import ReCAPTCHA from 'react-google-recaptcha'

import { settings } from '../../../../main/configs/settings'
import { fetchMe } from '../../../../main/usecases'

import { setUser, goToUrl, exceptionsError } from '../../../utils'
import { useForm } from '../../../hooks'
import { Button, InputPassword } from '../../../components'
import { CardContainer } from '../../../components/ui/components'

import { ArrowRightSvg, FullLogoSvg } from '../../../assets/icons/svgComponents'

import * as S from './styles'

type recpatchaParams = {
  items?: any
  text?: string
  isVerified?: boolean
  expired?: boolean
}

const SignupPassword = () => {
  const [loading, setLoading] = useState(false)
  const password = useForm('password')
  const confirmPassword = useForm('confirmPassword')
  const history = useHistory()
  const { email }: any = history?.location?.state || null
  const alert = useAlert()
  const [recpatchaState, setRecpatchaState] = useState<recpatchaParams>({
    items: [],
    text: '',
    isVerified: false,
    expired: false
  })
  const handleChange = (value: string | null) => {
    if (value) {
      setRecpatchaState({ isVerified: true })
    }
    // if value is null recaptcha expired
    if (value === null) setRecpatchaState({ expired: true })
  }
  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      setLoading(true)
      await Auth.signUp({
        username: email,
        password: password.value,
        attributes: {
          email: email
        }
      })
      await Auth.signIn(email.toLowerCase(), password.value)
      const me = await fetchMe().load()
      await setUser(me)

      goToUrl(history, settings.dashboardRoute)
    } catch (error: any) {
      console.log(error)
      alert.show(exceptionsError(error.code, error.message), {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <S.Wrapper>
      <CardContainer style="container-senha">
        <S.Content>
          <FullLogoSvg
            colorX="#00995D"
            colorLetters="#6F6F6E"
            width="182"
            height="42"
          />
          <S.Subtitle>Seja bem-vindo(a)!</S.Subtitle>
          <S.Description>Escolha uma senha</S.Description>
          <form onSubmit={onSubmit}>
            <InputPassword
              labelColor="#4F4F4F"
              label="Senha"
              name="password"
              topEyer="37px"
              topEyerBlock="35px"
              {...password}
            />
            <InputPassword
              onKeyUp={() => confirmPassword.validate()}
              labelColor="#4F4F4F"
              label="Confirmar senha"
              name="confirmPassword"
              topEyer="37px"
              topEyerBlock="35px"
              {...confirmPassword}
              error={
                confirmPassword.value &&
                password.value &&
                confirmPassword.value !== password.value
                  ? 'As senhas não são iguais'
                  : ''
              }
            />
            <S.PasswordRequirements>
              Precisa no mínimo 8 digitos
            </S.PasswordRequirements>
            <ReCAPTCHA
              sitekey={String(settings.RECAPTCHA)}
              onChange={handleChange}
              className="recaptcha"
            />
            <S.ButtonContainer>
              {loading ? (
                <Button
                  disabled
                  endIcon={<ArrowRightSvg className="icon-arrow-right" />}
                >
                  Prosseguindo...
                </Button>
              ) : (
                <Button
                  disabled={
                    !recpatchaState.isVerified ||
                    confirmPassword.error ||
                    password.error ||
                    !password.value ||
                    !confirmPassword.value
                  }
                  endIcon={<ArrowRightSvg className="icon-arrow-right" />}
                >
                  Prosseguir
                </Button>
              )}
            </S.ButtonContainer>
          </form>
        </S.Content>
      </CardContainer>
    </S.Wrapper>
  )
}
export default SignupPassword
